/* Breast Cancer Awareness Month page: swatch / size / variant logic. Scoped to [data-tu-aw-band].
   Cart add is NOT handled here: assets/tu-cart-drawer.js intercepts form[action*="/cart/add"]. */
(function () {
  'use strict';
  function sized(url, w) {
    return /([?&])width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(url, widths) { return widths.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', '); }

  function init(band) {
    var dataEl = band.querySelector('[data-aw-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var main = band.querySelector('[data-aw-main]');
    var thumbs = band.querySelector('[data-aw-thumbs]');
    var swatches = [].slice.call(band.querySelectorAll('.tu-aw-sw'));
    var sizeBtns = [].slice.call(band.querySelectorAll('.tu-aw-sz'));
    var cv = band.querySelector('[data-aw-cv]');
    var sv = band.querySelector('[data-aw-sv]');
    var price = band.querySelector('[data-aw-price]');
    var idEl = band.querySelector('[data-aw-id]');
    var cart = band.querySelector('[data-aw-cart]');
    var pressed = function (list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0]; };
    var state = {
      color: (pressed(swatches) || swatches[0]).getAttribute('data-color'),
      size: (pressed(sizeBtns) || sizeBtns[0]).getAttribute('data-size')
    };

    function variant(color, size) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.color === color && v.size === size) return v;
      }
      return null;
    }

    function setMain(url, alt) {
      if (!main || !url) return;
      main.srcset = srcset(url, [400, 600, 800, 1000, 1200]);
      main.src = sized(url, 800);
      main.alt = alt;
    }

    function buildThumbs(c) {
      if (!thumbs) return;
      thumbs.textContent = '';
      c.photos.forEach(function (url, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tu-aw-thumb';
        b.setAttribute('aria-label', 'Photo ' + (k + 1) + ' of ' + c.photos.length);
        b.setAttribute('aria-current', String(k === 0));
        var im = document.createElement('img');
        im.src = sized(url, 300); im.alt = ''; im.width = 300; im.height = 300; im.loading = 'lazy';
        b.appendChild(im);
        thumbs.appendChild(b);
      });
      if (window.TuSkel) window.TuSkel.observe(thumbs);
    }

    // 2026-10-08: one delegated listener, so the thumbnails rendered by Liquid on page load work too (before, only the
    // thumbnails rebuilt after a swatch click had listeners, and clicking a thumbnail on load did nothing).
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.tu-aw-thumb');
      if (!t || !thumbs.contains(t)) return;
      var k = [].indexOf.call(thumbs.children, t);
      var c = data.colors.filter(function (x) { return x.name === state.color; })[0];
      if (!c || !c.photos[k]) return;
      setMain(c.photos[k], data.title + ', ' + c.name);
      [].forEach.call(thumbs.children, function (o) { o.setAttribute('aria-current', String(o === t)); });
    });

    function refresh() {
      var v = variant(state.color, state.size);
      // sizes that do not exist or are sold out in this colour are disabled
      sizeBtns.forEach(function (b) {
        var sv2 = variant(state.color, b.getAttribute('data-size'));
        b.disabled = !(sv2 && sv2.available);
        b.setAttribute('aria-pressed', String(b.getAttribute('data-size') === state.size));
      });
      if (cv) cv.textContent = state.color;
      if (sv) sv.textContent = state.size;
      if (v) {
        if (price) price.textContent = v.price;
        if (idEl) idEl.value = v.id;
      }
      var ok = !!(v && v.available);
      if (cart) { cart.disabled = !ok; cart.textContent = ok ? 'Add to cart' : 'Sold out'; }
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        state.color = b.getAttribute('data-color');
        swatches.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        var v = variant(state.color, state.size);
        if (!(v && v.available)) {
          // keep the size if the new colour has it, else the first size that is in stock
          for (var i = 0; i < sizeBtns.length; i++) {
            var s = sizeBtns[i].getAttribute('data-size'), sv2 = variant(state.color, s);
            if (sv2 && sv2.available) { state.size = s; break; }
          }
        }
        var c = data.colors.filter(function (x) { return x.name === state.color; })[0];
        if (c && c.photos.length) { setMain(c.photos[0], data.title + ', ' + c.name); buildThumbs(c); }
        refresh();
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.size = b.getAttribute('data-size');
        refresh();
      });
    });
    refresh();
  }

  [].forEach.call(document.querySelectorAll('[data-tu-aw-band]'), init);
  if (window.TuSkel) window.TuSkel.observe(document.querySelector('[data-tu-aw]'));
})();
